/* unplugin-vue-components disabled */import script from "./problemItem.vue?vue&type=script&setup=true&lang=js"
export * from "./problemItem.vue?vue&type=script&setup=true&lang=js"

import "./problemItem.vue?vue&type=style&index=0&id=618f6fad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-618f6fad"]])

export default __exports__